import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { getQuery, getLimitOptions } from 'utilities/query';
import adverseEventService from '../adverse-event/adverse-event.service';
import adverseEventsComponent from './adverse-events.component';
import search from './adverse-event-search/adverse-event-search.module';

import './adverse-events.scss';

export default
  angular.module('components.app.adverseEvents', [
    uiRouter,
    search
  ])
    .component('adverseEvents', adverseEventsComponent)
    .service('AdverseEventService', adverseEventService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('adverseEvents', {
          parent: 'app',
          url: '/adverse-events',
          component: 'adverseEvents',
          params: {
            search: {
              value: 'default'
            }
          },
          resolve: {
            flex: () => '100',
            layout: () => 'column',
            query: () => getQuery(),
            limitOptions: () => getLimitOptions(),
            adverseEvents: ($stateParams, query, AdverseEventsService) => {
              AdverseEventsService.setQuery(query);

              if (!$stateParams.search) {
                return AdverseEventsService.getAdverseEvents().then(r => r.data);
              }

              if ($stateParams.search === 'status_open') {
                return AdverseEventsService.getAdverseEventsByStatus('OPEN')
                  .then(r => r.data);
              }

              return AdverseEventsService.getAdverseEvents().then(r => r.data);
            },
            alerts: AdverseEventsService =>
              AdverseEventsService.getAlerts().then(r => r.data),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            eventTypes: AdverseEventsService =>
              AdverseEventsService.getEventTypes(),
            searchCriteria: ($stateParams) => {
              let selectedSearchType = 'All Adverse Events';
              if ($stateParams.search === 'status_open') {
                selectedSearchType = 'Open Adverse Events';
              }

              return {
                selectedSearchType
              };
            },
            searchTypes: AdverseEventsService =>
              AdverseEventsService.getSearchTypes(),
            sexes: AdverseEventService => AdverseEventService.getAnimalSexes(),
            statuses: AdverseEventService => AdverseEventService.getStatuses(),
            symptoms: AdverseEventService => AdverseEventService.getSymptoms(),
            occurrenceLikelihoods: AdverseEventService => AdverseEventService.getOccurrenceLikelihoods(),
            injuryProbabilities: AdverseEventService => AdverseEventService.getInjurityProbabilities(),
            injurySeverities: AdverseEventService => AdverseEventService.getInjuritySeverities()
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-events.module.js